import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useB3Config } from "./B3Provider/useB3Config.js";
export function StyleRoot(t0) {
  const $ = _c(4);
  const {
    children,
    id
  } = t0;
  const {
    theme
  } = useB3Config();
  let t1;
  if ($[0] !== children || $[1] !== id || $[2] !== theme) {
    t1 = _jsx("div", {
      className: "b3-root",
      id,
      "data-theme": theme,
      children
    });
    $[0] = children;
    $[1] = id;
    $[2] = theme;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}